import { useContext } from 'react'
import { useLocation, Outlet } from 'react-router'
import { AuthContext } from '@/context/auth-context'
import { BrandEnum } from '@/firebase/auth/auth-jwt-schema'

interface BrandAccessGuardProps {
  excludedBrands: BrandEnum[]
  message?: string
}

/**
 * Brand Access Guard
 * Restricts access to features based on user's brand
 * Shows a message if the user's brand is in the excluded list
 * Otherwise renders the child routes via Outlet
 */
export default function BrandAccessGuard({ excludedBrands, message }: BrandAccessGuardProps) {
  const location = useLocation()
  const { userAccountData } = useContext(AuthContext)
  const userBrand = userAccountData?.brand ?? BrandEnum.NONE

  if (excludedBrands.includes(userBrand)) {
    console.log(`Access denied to ${location.pathname} for brand: ${userBrand}`)
    return (
      <div className="flex-grow flex flex-col justify-center items-center lg:min-h-screen py-2 pb-4">
        <div className="text-center">
          <h2 className="text-xl font-semibold text-brand-neutral-950 mb-2">Feature Not Available</h2>
          <p className="text-brand-neutral-700">{message || 'This feature is not available for your organization.'}</p>
        </div>
      </div>
    )
  }

  return <Outlet />
}
